export default {
  env: 'development',
  login: {
    url: '/api/login',
    jwt: 'authorization',
  },
  api: {
    url: 'https://api.di-dev.prismamp.com/backoffice-bff/prepaidcard',
    jwt: 'authorization',
    issuer: 'XPERIENCE',
    app: 'APP',
  },
  authentication: {
    client_id: 'backoffice',
    authority_url: 'https://auth.di-dev.prismamp.com/',
  },
};